import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type ProductOfferBoxGenericLabelProps = ComponentPropsWithoutRef<'button'>

export const ProductOfferBoxGenericLabel: FC<
  ProductOfferBoxGenericLabelProps
> = ({ className, ...rest }) => (
  <button
    className={clsx(
      className,
      'mr-2.5 flex items-center rounded-full border px-2 py-1 text-xs',
      !rest.onClick && 'cursor-default',
    )}
    type="button"
    {...rest}
  />
)
